import React from "react";
import { Globe2 } from "lucide-react";
import { RegistrationLinks } from "@/components/settings/tenant/RegistrationLinks";
import { DomainsManager } from "@/components/settings/tenant/DomainsManager";

export function AffiliatePortal() {
  return (
    <div className="max-w-3xl space-y-6" data-testid="affiliate-portal">
      <div className="flex items-start gap-3 rounded-xl border border-white/[0.08] bg-[#141417] p-4">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/[0.05]"><Globe2 className="h-4 w-4 text-muted-foreground" /></span>
        <div>
          <div className="text-sm font-medium text-foreground">Your affiliate portal</div>
          <p className="mt-0.5 text-sm text-muted-foreground">Webmasters log in & register on your own portal — at <span className="text-foreground">{"{slug}.affilix.io"}</span> or your custom domain. Configure links, connect domains, and tune Registration & Branding in their tabs.</p>
        </div>
      </div>
      <RegistrationLinks />
      <div className="space-y-3">
        <h3 className="text-sm font-medium text-foreground">Custom domains</h3>
        <DomainsManager />
      </div>
    </div>
  );
}
